export const defaultMilestones = [
  {
    year: "2020",
    title: "Founded",
    description: "Started with a vision to bring quality products to Sri Lanka",
  },
  {
    year: "2021",
    title: "First Store",
    description: "Opened our flagship store in Colombo",
  },
  {
    year: "2022",
    title: "Online Launch",
    description: "Launched e-commerce platform for nationwide delivery",
  },
  {
    year: "2023",
    title: "100K+ Customers",
    description: "Reached 100,000 happy customers across the island",
  },
  {
    year: "2024",
    title: "Expanded Catalog",
    description: "Added 500+ new products across 20 categories",
  },
];

export const defaultValues = [
  {
    icon: "Heart",
    title: "Customer First",
    description:
      "Every decision starts with our customers' needs and satisfaction",
  },
  {
    icon: "Award",
    title: "Quality Guaranteed",
    description: "We source only the best products from trusted suppliers",
  },
  {
    icon: "Sparkles",
    title: "Innovation",
    description: "Constantly improving our service and product selection",
  },
  {
    icon: "Users",
    title: "Community",
    description:
      "Building lasting relationships with our customers and partners",
  },
];

export const defaultTeam = [
  {
    name: "Sarah Fernando",
    role: "Founder & CEO",
    bio: "15+ years in retail and e-commerce",
  },
  {
    name: "Rajesh Kumar",
    role: "Operations Director",
    bio: "Expert in supply chain and logistics",
  },
  {
    name: "Priya Silva",
    role: "Head of Customer Experience",
    bio: "Passionate about exceptional service",
  },
  {
    name: "Ahmed Hassan",
    role: "Technology Lead",
    bio: "Building seamless digital experiences",
  },
];

export const defaultContactInfo = [
  {
    icon: "Mail",
    title: "Email Us",
    value: "info@example.com",
    href: "mailto:info@example.com",
    description: "We typically respond within 24 hours",
  },
  {
    icon: "Phone",
    title: "Call Us",
    value: "+94 77 123 4567",
    href: "tel:+94771234567",
    description: "Mon - Fri: 9:00 AM - 6:00 PM",
  },
  {
    icon: "MapPin",
    title: "Visit Us",
    value: "123 Main Street, Colombo 03, Sri Lanka",
    href: "#",
    description: "Our physical store location",
  },
  {
    icon: "Clock",
    title: "Business Hours",
    value: "Mon - Sat: 9:00 AM - 8:00 PM",
    href: "#",
    description: "Sunday: 10:00 AM - 5:00 PM",
  },
];

export const defaultFaqs = [
  {
    question: "How long does delivery take?",
    answer:
      "Standard delivery takes 2-5 business days island-wide. Express delivery (1-2 days) is available for Colombo and suburbs.",
  },
  {
    question: "What is your return policy?",
    answer:
      "We offer a 30-day hassle-free return policy. Items must be in original condition with tags attached. Refunds are processed within 5-7 business days.",
  },
  {
    question: "Do you offer cash on delivery?",
    answer:
      "Yes, cash on delivery is available for orders up to LKR 50,000. A small handling fee of LKR 100 applies.",
  },
  {
    question: "How can I track my order?",
    answer:
      "Once your order ships, you'll receive an SMS and email with tracking details. You can also track from your account dashboard.",
  },
  {
    question: "What payment methods do you accept?",
    answer:
      "We accept credit/debit cards, bank transfers, mobile payments (eZ Cash, Genie), and cash on delivery.",
  },
  {
    question: "Is there a minimum order for free shipping?",
    answer:
      "Yes, free standard shipping on orders over LKR 5,000. Standard shipping is LKR 300 for orders below this amount.",
  },
];

export const defaultSocialLinks = [
  { name: "Facebook", href: "#", icon: "Facebook" },
  { name: "Instagram", href: "#", icon: "Instagram" },
  { name: "Twitter", href: "#", icon: "Twitter" },
];

export const defaultBusinessHours = [
  {
    title: "Monday - Saturday",
    value: "9:00 AM - 8:00 PM",
    href: "#",
    description: "",
  },
  { title: "Sunday", value: "10:00 AM - 5:00 PM", href: "#", description: "" },
];

export const defaultHeroContent = [
  {
    hero_title: "Welcome to Our Store",
    hero_subtitle: "Discover amazing products at the best prices",
    button_text: "Shop Now",
  },
];

export const defaultAboutUs = [
  {
    about_title: "About Us",
    about_content:
      "We are a team of passionate individuals dedicated to providing the best shopping experience. With years of experience in the industry, we source only the finest products for our customers.",
    about_image: "",
  },
];

export const defaultFooterContent = [
  {
    copyright_text: "Copyright 2024. All rights reserved.",
    footer_description:
      "Your trusted partner for quality products and exceptional service.",
    footer_email: "info@example.com",
    footer_phone: "+94 77 123 4567",
  },
];
